<!-- class students list -->
<template>
  <div class="content has_breadcrumb journal-inner">
    <base-breadcrumb
      :data="[
        {
          routeName: 'locations',
          name: user.schoolName
        },
        {
          routeName: 'journal',
          name: 'Journal'
        },
        {
          path: '/journal/class/' + classId,
          name: classname,
          // path 型链接只带显式 query（baseBreadcrumb 不透传 $route.query）：
          // 回 class 页需携带 R32 标签与 year，避免类目段标签缺失降级
          query: { className: classname, year: $route.query.year || '' }
        },
        {
          name: journalData.title
        }
      ]"
      slot="breadcrumb"
    />
    <GgPage pageType="" title="Journal">
      <div slot="topAppBar">
        <search />
      </div>
      <div class="journal-list-inner">
        <div
          class="journal-create-main"
          v-loading="loading"
          :style="{
            paddingTop:
              (isPdfNewsletter
                ? '130'
                : createTypeName[createType] === 'portfolio'
                  ? '130'
                  : '96') + 'px'
          }"
          :class="[createTypeName[createType], { 'pdf-newsletter-detail': isPdfNewsletter }]"
        >
          <div class="journal-top-fixed">
            <div class="title">
              <div class="tit" v-if="journalData.title">
                {{ htmlDecode(journalData.title) }}
                <i
                  v-if="isPdfNewsletter"
                  class="iconfont iconedit pdf-title-edit"
                  @click="openPdfTitleDialog"
                ></i>
                <span v-if="isPdfNewsletter" class="pdf-title-chip">PDF</span>
              </div>

              <div
                class="journal-people-tag"
                v-if="createTypeName[createType] === 'portfolio' && journalStuInfo"
              >
                <div class="tag">
                  <span
                    class="avatar"
                    :style="'background-image:url(' + journalStuInfo.photo + ')'"
                    v-if="journalStuInfo.photo"
                  ></span>
                  <div class="no" v-else>
                    <img src="@/assets/images/icons/person_black_24dp.svg" />
                  </div>
                  <!-- <div class="no" v-else>
                    {{ journalStuInfo.firstName ? journalStuInfo.firstName.substring(0, 1).toUpperCase() : '-' }}{{ journalStuInfo.lastName ? journalStuInfo.lastName.substring(0, 1).toUpperCase() : '-' }}
                  </div> -->
                  <span class="name">{{
                    journalStuInfo.firstName + ' ' + journalStuInfo.lastName
                  }}</span>
                </div>
              </div>

              <div class="des" v-if="journalPortfolioRecord">
                <div class="avatar" v-if="journalPortfolioRecord.photo">
                  <img :src="journalPortfolioRecord.photo" />
                </div>
                <div class="no" v-else>
                  {{
                    journalPortfolioRecord.firstName
                      ? journalPortfolioRecord.firstName.substring(0, 1).toUpperCase()
                      : '-'
                  }}{{
                    journalPortfolioRecord.lastName
                      ? journalPortfolioRecord.lastName.substring(0, 1).toUpperCase()
                      : '-'
                  }}
                </div>
                <div class="name">
                  {{
                    (journalPortfolioRecord.firstName || '-') +
                    ' ' +
                    (journalPortfolioRecord.lastName || '-')
                  }}
                </div>
                <div v-if="journalRole && journalRole.name === 'Company admin'" class="tag">
                  Company admin
                </div>
                <div v-else class="tag">{{ (journalRole && journalRole.roleName) || '-' }}</div>
                <div class="date" v-if="journalData.status === 'POSTED'">
                  posted on {{ momentTime((journalRecord || journalPortfolioRecord).timestamp) }}
                </div>
                <div class="date" v-else>
                  saved on {{ momentTime(journalPortfolioRecord.timestamp) }}
                </div>
              </div>

              <div class="draft-col" v-if="menuData.length > 0">
                <gg-menu-bar>
                  <i class="iconmore_vert-24px iconfont" />
                  <template slot="menus">
                    <gg-menu-bar-item
                      :class="{ 'hr-class': menuitem === '|' }"
                      v-for="(menuitem, key) in menuData"
                      @click="menuClick(menuitem)"
                      :key="key"
                    >
                      <span>{{ menuitem === '|' ? '' : menuitem }}</span>
                      <hr v-if="menuitem === '|'" class="hr" />
                    </gg-menu-bar-item>
                  </template>
                </gg-menu-bar>
              </div>
            </div>
          </div>

          <div class="journal-page-main">
            <div class="journal-page-list" v-if="!isPdfNewsletter">
              <div class="journal-page-box" v-for="(item, index) in journalPageList" :key="index">
                <div class="journal-page-bar-inner">
                  <div class="journal-page-bar">
                    <div class="journal-page-num">
                      Page {{ index + 1 }}/{{ journalPageList.length }}
                    </div>
                  </div>
                </div>
                <div class="journal-page">
                  <components
                    v-if="item.no"
                    :data="item.data"
                    :index="index"
                    :is="item.no + '-s'"
                  ></components>
                </div>
              </div>
            </div>
            <div class="pdf-page-list" v-else>
              <div class="pdf-page-box" v-for="(image, index) in pdfImageList" :key="index">
                <div class="pdf-page-num">Page {{ index + 1 }}/{{ pdfImageList.length }}</div>
                <img :src="normalizePdfImagePath(image)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <gg-Dialog
        width="580px"
        :visible.sync="journalDeleteSw"
        :title="'Delete ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once deleted, you will not be able to recover the
          {{ journalType === 0 ? 'newsletter' : 'portfolio' }} data.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalDeleteSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalDelete">Delete</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalSubmitSw"
        :title="'Submit ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once submitted, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will be subjected
          to approval for sharing.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalSubmitSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalSubmit">Submit</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalUndoSw"
        :title="'Undo submission?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once undone, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will change from
          pending to draft.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalUndoSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalUndo">Undo</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalApproveSw"
        :title="'Approve ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once approved, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will be shared and
          viewed by parents.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalApproveSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalApprove">Approve</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="journalRecallSw"
        :title="'Recall ' + (journalType === 0 ? 'newsletter' : 'portfolio') + '?'"
        class="draft-dialog mp-dialog"
      >
        <div class="dialogContent">
          Once recalled, the {{ journalType === 0 ? 'newsletter' : 'portfolio' }} will change from
          posted to draft and not be seen by parents.
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="journalRecallSw = false">Cancel</gg-cancel-button>
          <gg-submit-button @click="journalRecall">Recall</gg-submit-button>
        </span>
      </gg-Dialog>

      <gg-Dialog
        width="580px"
        :visible.sync="pdfTitleDialogSw"
        title="Change Newsletter Title"
        class="pdf-title-dialog"
        :before-close="closePdfTitleDialog"
      >
        <div class="pdf-title-form">
          <div class="pdf-title-field" :class="{ error: pdfTitleError }">
            <label>Newsletter title *</label>
            <input
              ref="pdfTitleInput"
              v-model.trim="pdfTitle"
              maxlength="80"
              autocomplete="off"
              @keyup.enter="savePdfTitle"
            />
          </div>
          <div class="pdf-title-meta">
            <div class="pdf-title-error">{{ pdfTitleError }}</div>
            <div class="pdf-title-count">{{ pdfTitle.length }} / 40</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <gg-cancel-button @click="closePdfTitleDialog">Cancel</gg-cancel-button>
          <gg-submit-button :disabled="pdfTitleSaveDisabled" @click="savePdfTitle">
            Save
          </gg-submit-button>
        </span>
      </gg-Dialog>

      <Snackbar :visible.sync="loadingShow" :content="loadingText" />
    </GgPage>
  </div>
</template>

<script>
import moment from 'moment'
import { Ajax } from '@/common'
import { saveDraft, classIdOf, classNameOf } from '@/common/nav-state'
import { mapState } from 'vuex'
import { htmlDecode, hasPermission } from './../utils/utils.js'
import {
  pdfGenerating,
  pdfEditable,
  canUndoJournal,
  canRecallJournal,
  approvalErrorMessage
} from './../utils/pdf-list-state'
import search from './../modules/search'
import newsletterAS from './../modules/model/newsletterAS'
import newsletterOS from './../modules/model/newsletterOS'
import newsletterBS from './../modules/model/newsletterBS'
import newsletterCS from './../modules/model/newsletterCS'
import newsletterDS from './../modules/model/newsletterDS'
import newsletterES from './../modules/model/newsletterES'
import newsletterFS from './../modules/model/newsletterFS'
import newsletterGS from './../modules/model/newsletterGS'
import newsletterHS from './../modules/model/newsletterHS'
import newsletterIS from './../modules/model/newsletterIS'
import newsletterJS from './../modules/model/newsletterJS'
import newsletterKS from './../modules/model/newsletterKS'
import newsletterLS from './../modules/model/newsletterLS'
import newsletterMS from './../modules/model/newsletterMS'
import newsletterNS from './../modules/model/newsletterNS'
import portfolioAS from './../modules/model/portfolioAS'
import portfolioBS from './../modules/model/portfolioBS'
import portfolioCS from './../modules/model/portfolioCS'
import portfolioDS from './../modules/model/portfolioDS'
import portfolioES from './../modules/model/portfolioES'

export default {
  components: {
    search,
    newsletterAS,
    newsletterOS,
    newsletterBS,
    newsletterCS,
    newsletterDS,
    newsletterES,
    newsletterFS,
    newsletterGS,
    newsletterHS,
    newsletterIS,
    newsletterJS,
    newsletterKS,
    newsletterLS,
    newsletterMS,
    newsletterNS,
    portfolioAS,
    portfolioBS,
    portfolioCS,
    portfolioDS,
    portfolioES
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    isPdfNewsletter() {
      const item = this.journalData || {}
      return Boolean(
        item.isPdf === true ||
        item.pdfNewsletter === true ||
        item.isPdfNewsletter === true ||
        (Array.isArray(item.pdfImages) && item.pdfImages.length) ||
        (Array.isArray(item.pdfThumbnailImages) && item.pdfThumbnailImages.length) ||
        (Array.isArray(item.imagePaths) && item.imagePaths.length)
      )
    },
    pdfImageList() {
      const item = this.journalData || {}
      const images = item.pdfImages || item.pdfThumbnailImages || item.imagePaths || []
      return Array.isArray(images) ? images.filter(Boolean) : []
    },
    pdfTitleError() {
      if (this.pdfTitle.length > 40) {
        return 'Character limit of 40'
      }
      return this.pdfTitleApiError
    },
    pdfTitleSaveDisabled() {
      return (
        this.pdfTitleSaving ||
        !this.pdfTitle ||
        this.pdfTitle.length > 40 ||
        Boolean(this.pdfTitleApiError)
      )
    }
  },
  data() {
    return {
      journalRole: null,
      journalType: 0,
      journalIndex: '',
      journalRecallSw: false,
      journalApproveSw: false,
      journalUndoSw: false,
      journalSubmitSw: false,
      journalDeleteSw: false,
      loading: false,
      loadingText: '',
      loadBtn: false,
      classId: '',
      classname: '',
      loadingShow: false,
      journalPortfolioRecord: null,
      journalData: {},
      menuData: [],
      journalStuInfo: null,
      journalPageList: [],
      rootPath: process.env.VUE_APP_fileBasePath,
      journalRecord: null,
      height: '',
      createType: '',
      createTypeName: ['newsletter', 'portfolio'],
      createTypeArr: ['Create a newsletter', 'Create a portfolio'],
      pdfTitleDialogSw: false,
      pdfTitle: '',
      pdfTitleApiError: '',
      pdfTitleSaving: false,
      journalCreatorId: '',
      journalRefreshTimer: null,
      journalDestroyed: false
    }
  },
  watch: {
    pdfTitle() {
      this.pdfTitleApiError = ''
    },
    // A→B 组件复用（journalDraft→journalDraft）：按新身份重播种上下文、清旧记录弹窗/暂存、重取
    //（旧记录在途响应由取数函数的 reqId 栅栏按请求身份丢弃）
    '$route.query.id'(newId) {
      if (!newId) return
      this._resetJournalViewState()
      this._seedJournalContext()
      this.getJournal()
    }
  },
  created() {
    this._seedJournalContext()
    this.getJournal()
  },
  mounted() {},
  beforeDestroy() {
    this.journalDestroyed = true
    clearTimeout(this.journalRefreshTimer)
  },
  methods: {
    moment,

    hasPermission,

    htmlDecode,

    dateDiff(date) {
      let a = moment.utc(date),
        b = moment()
      return a.diff(b, 'days')
    },

    normalizePdfImagePath(path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(path)) return path
      return `${process.env.VUE_APP_fileBasePath}${path}`
    },

    openPdfTitleDialog() {
      this.pdfTitle = this.htmlDecode(this.journalData.title || '')
      this.pdfTitleApiError = ''
      this.pdfTitleDialogSw = true
      this.$nextTick(() => {
        if (this.$refs.pdfTitleInput) {
          this.$refs.pdfTitleInput.focus()
        }
      })
    },

    closePdfTitleDialog() {
      if (this.pdfTitleSaving) return
      this.pdfTitleDialogSw = false
      this.pdfTitle = ''
      this.pdfTitleApiError = ''
    },

    savePdfTitle() {
      if (this.pdfTitleSaveDisabled || !this.isPdfNewsletter) return

      this.pdfTitleSaving = true
      const data = {
        ...this.journalData,
        title: this.pdfTitle,
        staffId: this.user.userId,
        isNewsletter: true
      }

      Ajax.put('/journal/' + this.journalData.id, data)
        .then((res) => {
          if (res.code === '0000') {
            this.journalData.title = this.pdfTitle
            this.pdfTitleDialogSw = false
            this.loadingText = 'Newsletter title has been changed'
            this.loadingShow = true
          } else {
            const message = res.message || res.msg || ''
            if (/title/i.test(message) || /exist/i.test(message)) {
              this.pdfTitleApiError = 'Title already exists'
            } else {
              this.loadingText = message || 'Save failed'
              this.loadingShow = true
            }
          }
        })
        .catch((error) => {
          const message = error && error.message ? error.message : 'Save failed'
          this.loadingText = message
          this.loadingShow = true
        })
        .finally(() => {
          this.pdfTitleSaving = false
        })
    },

    setJournalMenuData(item) {
      const menuData = ['Preview']
      if (pdfGenerating(item)) {
        this.menuData = menuData
        return
      }
      if (item.status === 'DRAFT' && this.hasPermission('Share journals_Create')) {
        menuData.push('Submit')
      }
      if (
        canUndoJournal(
          { ...item, creatorId: item.creatorId || this.journalCreatorId },
          this.user,
          this.hasPermission('Share journals_Edit')
        )
      ) {
        menuData.push('Undo')
      }
      if (
        item.status === 'PENDING' &&
        !pdfGenerating(item) &&
        !item.pdfGenerationToken &&
        this.hasPermission('Share journals_Full')
      ) {
        menuData.push('Approve')
      }
      if (
        item.status === 'POSTED' &&
        this.journalRecord &&
        canRecallJournal(this.journalRecord) &&
        this.hasPermission('Share journals_Full')
      ) {
        menuData.push('Recall')
      }
      if (
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        ((pdfEditable(item) &&
          !this.isPdfNewsletter &&
          this.hasPermission('Manage journals_Edit')) ||
          (!pdfGenerating(item) && this.hasPermission('Manage journals_Full')))
      ) {
        menuData.push('|')
      }
      if (
        !this.isPdfNewsletter &&
        pdfEditable(item) &&
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        this.hasPermission('Manage journals_Edit')
      ) {
        menuData.push('Edit')
      }
      if (
        (item.status === 'DRAFT' || item.status === 'PENDING') &&
        !pdfGenerating(item) &&
        this.hasPermission('Manage journals_Full')
      ) {
        menuData.push('Delete')
      }

      this.menuData = menuData
    },

    geJournalPortfolioRecord() {
      const reqId = this.$route.query.id
      let data = {
        journalId: reqId
      }
      Ajax.get('journal/' + reqId + '/record', data).then((res) => {
        if (reqId !== this.$route.query.id) return
        if (!this.journalDestroyed && res.code === '0000' && res.data) {
          this.journalPortfolioRecord = res.data
          this.geJournalRole(res.data.userId)
        }
      })
    },

    geJournalRecord(np) {
      if (np.status !== 'POSTED') return
      const reqId = this.$route.query.id
      const url = 'journal/' + np.id + '/record'
      const data = { journalId: np.id, event: 'POST' }
      return Ajax.get(url, data)
        .then((res) => {
          if (res.code === '0000' && res.data && res.data.timestamp) return res
          return Ajax.get(url, { ...data, event: 'APPROVE' })
        })
        .then((res) => {
          if (reqId !== this.$route.query.id) return
          if (!this.journalDestroyed && this.journalData.id === np.id && res.code === '0000') {
            this.journalRecord = res.data
            this.setJournalMenuData(this.journalData)
          }
        })
        .catch(() => null)
    },

    getJournalCreator(id) {
      if (!id) return
      const reqId = this.$route.query.id
      Ajax.get('journal/' + id + '/record', { journalId: id, event: 'CREATE' })
        .then((res) => {
          if (reqId !== this.$route.query.id) return
          if (!this.journalDestroyed && this.journalData.id === id && res.code === '0000') {
            this.journalCreatorId = (res.data && res.data.userId) || ''
            this.setJournalMenuData(this.journalData)
          }
        })
        .catch(() => null)
    },

    scheduleJournalRefresh() {
      clearTimeout(this.journalRefreshTimer)
      if (this.journalDestroyed || !pdfGenerating(this.journalData)) return
      this.journalRefreshTimer = setTimeout(async () => {
        const id = this.journalData.id
        try {
          const res = await Ajax.get('journal/' + id, { id })
          if (this.journalDestroyed || this.journalData.id !== id || res.code !== '0000') return
          const previousStatus = this.journalData.status
          this.journalData = res.data
          this.setJournalMenuData(res.data)
          if (previousStatus !== res.data.status) {
            this.geJournalRecord(res.data)
            this.geJournalPortfolioRecord()
          }
        } catch (e) {
          // Retry transient failures on the next interval.
        } finally {
          this.scheduleJournalRefresh()
        }
      }, 10000)
    },

    getStudentsInfo(id) {
      const reqId = this.$route.query.id
      let data = {
        stuId: id
      }
      Ajax.get('/usermanage/student/selectByStuId', data).then((res) => {
        if (reqId !== this.$route.query.id) return
        if (res.code === '0000') {
          this.journalStuInfo = res.data
        }
      })
    },

    geJournalRole(id) {
      const reqId = this.$route.query.id
      let data = {
        userId: id
      }
      Ajax.get('/usermanage/role/findCommonUserRole', data).then((res) => {
        if (reqId !== this.$route.query.id) return
        if (res.code === '0000') {
          this.journalRole = res.data
        }
      })
    },

    // 身份上下文播种（created 与 A→B 复用共用）
    _seedJournalContext() {
      this.createType = this.$route.query.type || '0'
      this.classname = classNameOf(this.$route)
      this.classId = classIdOf(this.$route)
    },

    // P1-1：旧记录的对话框/暂存态与派生数据清理（A→B 复用）
    _resetJournalViewState() {
      clearTimeout(this.journalRefreshTimer)
      this.pdfTitleDialogSw = false
      this.pdfTitle = ''
      this.pdfTitleApiError = ''
      this.pdfTitleSaving = false
      this.journalRecallSw = false
      this.journalApproveSw = false
      this.journalUndoSw = false
      this.journalSubmitSw = false
      this.journalDeleteSw = false
      this.journalIndex = ''
      this.journalType = 0
      this.loadingText = ''
      this.loadingShow = false
      this.loadBtn = false
      this.journalData = {}
      this.journalPageList = []
      this.journalRecord = null
      this.journalPortfolioRecord = null
      this.journalStuInfo = null
      this.journalRole = null
      this.journalCreatorId = ''
      this.menuData = []
    },

    getJournal() {
      const reqId = this.$route.query.id
      let data = {
        id: reqId
      }
      Ajax.get('journal/' + reqId, data).then((res) => {
        if (reqId !== this.$route.query.id) return
        if (!this.journalDestroyed && res.code === '0000') {
          this.journalData = res.data
          this.journalPageList = this.isPdfNewsletter ? [] : JSON.parse(res.data.content || '[]')
          this.geJournalRecord(res.data)
          this.getStudentsInfo(res.data.recipient)
          this.geJournalPortfolioRecord()
          this.getJournalCreator(res.data.id)
          this.scheduleJournalRefresh()

          if (res.data.status != 'POSTED') {
            this.setJournalMenuData(res.data)
          }
        }
      })
    },

    toPreview() {
      // 本地编辑内容预览：即使 journalData.id 存在也走 draft token（id 会显示服务端旧内容）；
      // journalId 等 PDF 重试字段随 payload 透传，语义等同原 storage 覆盖
      const draftToken = saveDraft('journalEditor', {
        pageData: JSON.stringify(this.journalPageList),
        title: this.journalData.title,
        status: this.journalData.status,
        filePath: this.journalData.filePath,
        isPdf: this.isPdfNewsletter ? 'true' : 'false',
        pdfImages: JSON.stringify(this.pdfImageList),
        journalId: (this.journalData && this.journalData.id) || '',
        pdfFailCount:
          this.journalData && this.journalData.pdfFailCount != null
            ? String(this.journalData.pdfFailCount)
            : '0',
        pdfGenerationToken: (this.journalData && this.journalData.pdfGenerationToken) || ''
      })
      let url = this.$router.resolve({
        path:
          '/journal/view?type=' +
          this.createTypeName[this.createType] +
          '&draft=' +
          encodeURIComponent(draftToken)
      })
      let win = window.open(url.href, '_blank')
      win.onload = function () {
        setTimeout(function () {
          win.document.title = 'Preview'
        }, 100)
      }
    },

    journalRecall() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalRecallSw = false
      this.loading = true
      Ajax.put('/journal/' + this.journalIndex + '/recall?staffId=' + this.user.userId)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been recalled'

            setTimeout(() => {
              this.loadBtn = false
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_draft',
                classid = classIdOf(this.$route)
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(this.classname) +
                  '&classId=' +
                  encodeURIComponent(this.classId) +
                  '&year=' +
                  encodeURIComponent(this.$route.query.year || '')
              )
            }, 1500)
          } else {
            this.loading = false
            this.loadBtn = false
          }
        })
        .catch(() => {
          this.loading = false
          this.loadBtn = false
        })
    },

    journalRecallShow(id, type, item) {
      this.journalRecallSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalApprove() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalApproveSw = false
      this.loading = true
      Ajax.put(
        '/journal/' +
          this.journalIndex +
          '/process?approve=' +
          true +
          '&staffId=' +
          this.user.userId
      )
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') +
              (this.journalData.isPdf === true ? ' has been posted' : ' posting in progress')

            setTimeout(() => {
              this.loadBtn = false
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_pending',
                classid = classIdOf(this.$route)
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(this.classname) +
                  '&classId=' +
                  encodeURIComponent(this.classId) +
                  '&year=' +
                  encodeURIComponent(this.$route.query.year || '')
              )
            }, 1500)
          } else {
            this.loading = false
            this.loadBtn = false
            if (this.$message) this.$message.error(approvalErrorMessage(res))
          }
        })
        .catch((error) => {
          this.loading = false
          this.loadBtn = false
          if (this.$message) this.$message.error(approvalErrorMessage(error))
        })
    },

    journalApproveShow(id, type, item) {
      this.journalApproveSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalUndo() {
      Ajax.put('/journal/' + this.journalIndex + '/cancel?staffId=' + this.user.userId).then(
        (res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.journalUndoSw = false
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been moved to draft'

            setTimeout(() => {
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_draft',
                classid = classIdOf(this.$route)
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(this.classname) +
                  '&classId=' +
                  encodeURIComponent(this.classId) +
                  '&year=' +
                  encodeURIComponent(this.$route.query.year || '')
              )
            }, 1500)
          }
        }
      )
    },

    journalUndoShow(id, type, item) {
      this.journalUndoSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalSubmit() {
      if (this.loadBtn) {
        return
      }
      this.loadBtn = true
      this.journalSubmitSw = false
      this.loading = true
      Ajax.put('/journal/' + this.journalIndex + '/submit?staffId=' + this.user.userId)
        .then((res) => {
          if (res.code === '0000') {
            this.loadingShow = true
            this.loadingText =
              (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been submitted'

            setTimeout(() => {
              this.loadBtn = false
              let typename = (this.journalType === 0 ? 'newsletter' : 'portfolio') + '_pending',
                classid = classIdOf(this.$route)
              this.$router.push(
                '/journal/class/' +
                  classid +
                  '?typename=' +
                  typename +
                  '&className=' +
                  encodeURIComponent(this.classname) +
                  '&classId=' +
                  encodeURIComponent(this.classId) +
                  '&year=' +
                  encodeURIComponent(this.$route.query.year || '')
              )
            }, 1500)
          } else {
            this.loading = false
            this.loadBtn = false
          }
        })
        .catch(() => {
          this.loading = false
          this.loadBtn = false
        })
    },

    journalSubmitShow(id, type) {
      this.journalSubmitSw = true
      this.journalIndex = id
      this.journalType = type
    },

    journalDelete() {
      Ajax.delete('/journal/' + this.journalIndex + '?staffId=' + this.user.userId).then((res) => {
        if (res.code === '0000') {
          this.journalDeleteSw = false
          this.loadingText =
            (this.journalType === 0 ? 'Newsletter' : 'Portfolio') + ' has been deleted'
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500)
        }
      })
    },

    journalDeleteShow(id, type) {
      this.journalDeleteSw = true
      this.journalIndex = id
      this.journalType = type
    },

    toEdit(id, type) {
      this.$router.push({
        name: 'journalCreate',
        query: {
          editid: id,
          type: type,
          classname: this.$route.query.name,
          classid: classIdOf(this.$route),
          time: this.moment().valueOf(),
          className: this.classname,
          classId: this.classId,
          year: this.$route.query.year || ''
        }
      })
    },

    menuClick(e) {
      let id = this.journalData.id,
        type = this.journalData.newsletter ? 0 : 1

      if (e === 'Preview') {
        this.toPreview()
      }
      if (e === 'Submit') {
        this.journalSubmitShow(id, type)
      }
      if (e === 'Undo') {
        this.journalUndoShow(id, type)
      }
      if (e === 'Approve') {
        this.journalApproveShow(id, type)
      }
      if (e === 'Recall' && canRecallJournal(this.journalRecord)) {
        this.journalRecallShow(id, type)
      }
      if (e === 'Edit') {
        this.toEdit(id, type)
      }
      if (e === 'Delete') {
        this.journalDeleteShow(id, type)
      }
    },

    momentTime(date) {
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    }
  }
}
</script>
<style lang="less" scoped>
.journal-list-inner {
  margin: auto;
  width: 1353px;
}

.journal-create-main {
  position: relative;

  &.newsletter {
    .journal-page-main {
      width: 900px !important;
    }
  }

  &.portfolio {
    .journal-page-main {
      width: 1016px !important;
    }

    .journal-page-list,
    .journal-page-box {
      width: 660px !important;
    }

    .journal-page {
      width: 660px !important;
      height: 470px !important;
    }
  }

  .journal-top-fixed {
    position: fixed;
    left: 50%;
    top: 121px;
    z-index: 1;
    margin-left: -676px;
    width: 1353px;
    background: #fff;

    .journal-people-tag {
      padding: 0 0 10px 0;

      .tag {
        display: inline-block;
        padding: 0 6px 0 4px;
        height: 24px;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 16px;

        .avatar {
          display: inline-block;
          margin-right: 8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          vertical-align: middle;
          background-size: contain;
        }

        .no {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #b4b4b4;
          line-height: 16px;
          color: #fff;
          text-align: center;
          font-size: 12px;
          font-family: 'opensans-semibold';
        }

        .name {
          text-align: left;
          font-family: Roboto;
          font-size: 12px;
          color: #202124;
        }
      }
    }

    .title {
      position: relative;
      padding-left: 8px;
      padding-bottom: 26px;
      border-bottom: 1px solid #e3e3e3;
      color: #202124;

      .tit {
        margin-bottom: 10px;
        line-height: 27px;
        font-size: 22px;
        font-family: 'OpenSans-Bold';

        .pdf-title-edit {
          display: inline-block;
          margin-left: 14px;
          color: #5f6368;
          font-size: 18px;
          vertical-align: middle;
          cursor: pointer;
        }

        .pdf-title-chip {
          display: inline-block;
          margin-left: 8px;
          height: 18px;
          line-height: 18px;
          padding: 0 7px;
          border-radius: 9px;
          background: #1a73e8;
          color: #fff;
          font-family: Roboto;
          font-size: 11px;
          font-weight: 400;
          vertical-align: middle;
        }
      }

      .des {
        .no {
          display: inline-block;
          margin-right: 8px;
          width: 32px;
          height: 32px;
          background: #b4b4b4;
          border-radius: 50%;
          line-height: 32px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          font-family: 'OpenSans-Bold';
        }

        .avatar {
          margin-right: 8px;
          display: inline-block;
          width: 32px;
          height: 32px;
          vertical-align: middle;

          img {
            display: block;
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
        }

        .name {
          margin-right: 8px;
          display: inline-block;
          font-size: 12px;
          font-family: Roboto;
          font-weight: 400;
          line-height: 19px;
          color: #202124;
          vertical-align: middle;
        }

        .tag {
          margin-right: 8px;
          display: inline-block;
          padding: 4px 9px;
          height: 20px;
          font-family: Roboto;
          line-height: 12px;
          font-weight: 400;
          background: #e0e0e0;
          border-radius: 10px;
          font-size: 12px;
          vertical-align: middle;
        }

        .date {
          margin-right: 8px;
          display: inline-block;
          font-size: 12px;
          font-family: Roboto;
          font-weight: 400;
          line-height: 16px;
          color: #b4b4b4;
        }
      }

      .draft-col {
        position: absolute;
        right: 10px;
        top: 5px;
      }
    }
  }

  .journal-page-main {
    position: relative;
    width: 900px;
    overflow: hidden;

    .journal-page-list {
      float: right;
      padding-bottom: 112px;
      width: 470px;

      .add-page-btn {
        margin-top: 20px;
        height: 36px;
        line-height: 36px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        text-align: center;
        font-family: 'opensans-semibold';
        font-size: 14px;
        color: #5f6368;
        cursor: pointer;
      }

      .journal-page-box {
        position: relative;
        width: 470px;

        .journal-page-bar-inner {
          height: 54px;

          .journal-page-bar {
            line-height: 54px;
            overflow: hidden;

            .journal-page-num {
              float: left;
              color: #5f6368;
              font-family: Roboto;
              font-size: 14px;
            }

            .journal-page-col {
              display: none;
              float: right;

              img {
                display: inline-block;
                margin-left: 7px;
                vertical-align: middle;
                cursor: pointer;

                &.die {
                  color: #606367;
                  cursor: not-allowed;
                  opacity: 0.5;
                }
              }
            }
          }
        }

        .journal-page {
          width: 470px;
          height: 666px;
          background: #f3f3f3;
          border: 1px solid #f4f4f4;
        }
      }
    }
  }

  &.pdf-newsletter-detail {
    .journal-page-main {
      width: 1016px;
      margin: 0 auto;
      overflow: visible;
    }

    .pdf-page-list {
      width: 720px;
      margin: 0 auto;
      padding-bottom: 112px;
    }

    .pdf-page-box {
      margin-bottom: 24px;

      .pdf-page-num {
        margin-bottom: 12px;
        color: #5f6368;
        font-family: Roboto;
        font-size: 14px;
        line-height: 20px;
      }

      img {
        display: block;
        width: 720px;
        max-width: 100%;
        height: auto;
      }
    }
  }
}

.pdf-title-dialog {
  /deep/ .el-dialog__body {
    padding: 0;
  }

  .pdf-title-form {
    padding: 22px 20px 18px;
  }

  .pdf-title-field {
    border-bottom: 1px solid #1a73e8;
    padding-bottom: 6px;

    label {
      display: block;
      color: #1a73e8;
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 12px;
    }

    input {
      width: 100%;
      border: 0;
      outline: none;
      color: #202124;
      font-size: 16px;
      line-height: 24px;
      padding: 0;
      background: transparent;
    }

    &.error {
      border-bottom-color: #d93025;

      label {
        color: #d93025;
      }
    }
  }

  .pdf-title-meta {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    color: #202124;
    font-size: 12px;
    line-height: 18px;
  }

  .pdf-title-error {
    color: #d93025;
  }
}
</style>
